export default function (nga, admin) {
    let entity = admin.getEntity('prescriberType')
        .label('Prescriber Type')
    //.readOnly();

    entity.listView()
        .fields([
            nga.field('id').isDetailLink(true),
            nga.field('description').isDetailLink(true),
            nga.field('competences', 'reference_many')
                .label('COMPETENCES')
                .targetEntity(nga.entity('competence').url('competences'))
                .targetField(nga.field('name'))
                .singleApiCall(ids => ({'id': ids }))
        ])
        .sortDir('asc')
        .url('prescriberTypes');

    entity.creationView().fields([
        nga.field('description'),
        nga.field('description_es'),
        nga.field('description_ca'),

        nga.field('competences', 'reference_many')
            .label('COMPETENCES')
            .targetEntity(nga.entity('competence').url('competences'))
            .targetField(nga.field('name'))
    ]);

    entity.editionView().fields(entity.creationView().fields());
    entity.deletionView();

    return entity;
}


/** WEBPACK FOOTER **
 ** ./js/entities/prescribertype/config.js
 **/